import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from "recharts";

const LABELS = {
  growth: "Growth",
  consistency: "Consistency",
  frequency: "Frequency",
  engagement: "Engagement",
  seo: "SEO",
  performance: "Performance",
  quality: "Quality",
};

function scoreColor(v) {
  if (v >= 80) return "text-emerald-400";
  if (v >= 60) return "text-amber-400";
  if (v >= 40) return "text-orange-400";
  return "text-rose-500";
}

export default function ChannelScore({ score }) {
  if (!score) return null;
  const data = [{ name: "score", value: score.overall, fill: "hsl(22 100% 50%)" }];

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
      <div className="flex items-baseline justify-between mb-4">
        <h2 className="text-2xl font-bold tracking-tight">Channel Score</h2>
        <div className="overline">Proprietary algorithm</div>
      </div>
      <div data-testid="channel-score" className="card-flat p-6 sm:p-8 grid md:grid-cols-2 gap-8">
        <div className="flex flex-col items-center justify-center">
          <div className="relative w-64 h-64">
            <ResponsiveContainer width="100%" height="100%">
              <RadialBarChart innerRadius="80%" outerRadius="100%" data={data} startAngle={90} endAngle={-270}>
                <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
                <RadialBar background={{ fill: "hsl(var(--secondary))" }} dataKey="value" cornerRadius={999} />
              </RadialBarChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div data-testid="score-overall" className="text-6xl font-black tabular-nums">{score.overall}</div>
              <div className="overline mt-1">out of 100</div>
            </div>
          </div>
        </div>
        <div className="space-y-3">
          {Object.entries(score.criteria).map(([k, v]) => (
            <div key={k} data-testid={`score-${k}`} className="flex items-center gap-4">
              <div className="w-32 text-sm text-muted-foreground">{LABELS[k]}</div>
              <div className="flex-1 h-2 bg-secondary rounded-full overflow-hidden">
                <div className="h-full bg-primary" style={{ width: `${v}%` }} />
              </div>
              <div className={`w-12 text-right font-mono font-bold tabular-nums ${scoreColor(v)}`}>{v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
